module.exports = __webpack_public_path__ + "static/media/marivi.1106ac3c.jpg";